import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { sampleApiCall } from "../../../apiservice/authService";
import { formatCurrency } from "../../../utils/basic.utils";
import PaystackPop from "@paystack/inline-js";
import { PayPalButtons } from "@paypal/react-paypal-js";

import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

import { Modal } from "antd";
import { DollarOutlined, CreditCardOutlined } from "@ant-design/icons";
import {
  userCompleteBookPaymentStripe,
  userCompletePayPalSubscription,
  userCompleteStripe,
  userGetBookPaymentToken,
  userGetBookPaypalCapture,
  userGetBookPaypalCreateOrder,
  userGetSubcriptionPaymentToken,
} from "../../../apiservice/userService";
import {
  IBookPaymentResponse,
  IBookPaymentResponseData,
  IPaypalSubscriptionLink,
  ISubscriptionResponse,
  ISubscriptionResponseData,
  ISubscriptionResponseMeta,
} from "../../../apiservice/userService.type";

const OnlinePayment = () => {
  const [URLSearchParams] = useSearchParams();
  const [selectedGateway, setSelectedGateway] = useState(1);
  const [selectedGatewayIndex, setSelectedGatewayIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [gateway] = useState<any[]>([
    {
      id: 1,
      title: "Paystack",
      icon: <CreditCardOutlined />,
      description: "Pay securely in NGN",
    },
    {
      id: 2,
      title: "Stripe",
      icon: <DollarOutlined />,
      description: "Pay globally in USD",
    },
    {
      id: 3,
      title: "PayPal",
      icon: <DollarOutlined />,
      description: "Pay globally in USD",
    },
  ]);
  const [paymentDetails, setPaymentDetails] = useState<
    (ISubscriptionResponseData & IBookPaymentResponseData) | null
  >(null);
  const [paymentMeta, setPaymentMeta] =
    useState<ISubscriptionResponseMeta | null>(null);
  const [isPaypalModalOpen, setIsPaypalModalOpen] = useState(false);

  const [isStripeModalOpen, setIsStripeModalOpen] = useState(false);
  const [stripeClientSecret, setStripeClientSecret] = useState<string | null>(null);

  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLIC_KEY!
  );

  const defaultPaymentDetails = {
    title: "Monthly Subscription",
    amount: 10,
    expire: "",
    email: "testeremail@gmail.com",
    conversionRate: 1520,
  };

  const fetchPaymentDetails = async () => {
    try {
      const paymentDetails: ISubscriptionResponse & IBookPaymentResponse =
        URLSearchParams?.get("type") === "1"
          ? await userGetSubcriptionPaymentToken(
            URLSearchParams?.get("token") || "0"
          )
          : await userGetBookPaymentToken(URLSearchParams?.get("token") || "0");

      if (paymentDetails) {
        setPaymentDetails(paymentDetails?.data);
        setPaymentMeta(paymentDetails?.meta);
      } else {
        setError("Invalid Payment Token");
      }
    } catch {
      setError("Failed to load Payment Details");
    } finally {
      setLoading(false);
    }
  };

  const getPaypalLink = async () => {
    try {
      const paypalSubcriptionLink: IPaypalSubscriptionLink =
        await userCompletePayPalSubscription({
          paymentToken: URLSearchParams?.get("token"),
        });

      window.open(paypalSubcriptionLink.data.approveLink, "_blank");
    } catch {
      setError("Failed to load Payment Details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentDetails();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedGatewayIndex === 0) {
      payWithPayStack(paymentMeta?.paystackMetadata);
    } else if (selectedGatewayIndex === 1) {
      if (URLSearchParams?.get("type") === "1") {
        createStripePayment();
        return;
      }
      createStripeBookPayment();
    }
    else {
      if (URLSearchParams?.get("type") === "1") {
        getPaypalLink();
        return;
      }
      setIsPaypalModalOpen(true);
    }
  };

  const payWithPayStack = (meta: any) => {
    const paystack = new PaystackPop();
    paystack.newTransaction({
      key: process.env.REACT_APP_PAYSTACK_PK,
      email: paymentDetails?.user?.email || "annonymouslinkmie@gmail.com",
      amount:
        (paymentDetails?.subscriptionPricing?.paystackPlan?.amount ||
          paymentDetails?.currencies?.[0]?.amount ||
          0) * 100,
      currency: "NGN",
      metadata: meta || {},
      onSuccess: () => {
        alert("Payment successful! Restart the app to see updates.");
      },
      onCancel: () => {
        alert("Payment was cancelled.");
      },
    });
  };

  const createStripePayment = async () => {
    const res: any =
      await userCompleteStripe({
        paymentToken: URLSearchParams?.get("token"),
      });


    window.open(res.data.url, "_blank");
    // setStripeClientSecret(res.data.clientSecret);
    // setIsStripeModalOpen(true);
  };


  const createStripeBookPayment = async () => {
    const res: any =
      await userCompleteBookPaymentStripe({
        paymentToken: URLSearchParams?.get("token"),
      });


    window.open(res.data.url, "_blank");
    // setStripeClientSecret(res.data.clientSecret);
    // setIsStripeModalOpen(true);
  };

  if (loading) {
    return (
      <div className="p-4 text-center text-black dark:text-white">
        Loading payment details...
      </div>
    );
  }

  if (error) {
    return <div className="p-4 text-center text-red-500">{error}</div>;
  }

  return (
    <div className="p-2">
      <div className="max-w-2xl mx-auto bg-white dark:bg-stone-700 shadow-lg rounded-xl p-8 mt-4">
        <h1 className="text-3xl font-bold text-center text-blue-600 dark:text-blue-400 mb-6">
          Keyway App Your Subscription
        </h1>

        <div className="bg-gray-100 dark:bg-stone-700 p-5 rounded-md mb-6">
          <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
            Payment Summary
          </h2>
          <p className="text-sm text-gray-600 dark:text-stone-300 mb-1">
            <strong>Payment For:</strong>{" "}
            {paymentDetails?.subscriptionPricingTitle ||
              paymentDetails?.bookTitle +
              " Book Summary By " +
              paymentDetails?.book?.authorName}
          </p>
          <p className="text-sm text-gray-600 dark:text-stone-300">
            <strong>Price:</strong>{" "}
            {formatCurrency(
              paymentDetails?.subscriptionPricing?.price ||
              paymentDetails?.book?.price ||
              defaultPaymentDetails?.amount ||
              0
            )}
          </p>
          <p className="text-sm text-gray-600 dark:text-stone-300 mb-1">
            <strong>Email:</strong> {paymentDetails?.user?.email}
          </p>
          <p className="text-sm text-gray-600 dark:text-stone-300 mb-1">
            <strong>FullName :</strong> {paymentDetails?.user?.fullName}
          </p>
          <p className="text-sm text-gray-600 dark:text-stone-300 mb-1">
            <strong>Payment Expire At :</strong> {"N/A"}
          </p>
        </div>

        <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-4">
          Choose Payment Gateway
        </h2>
        <div className="grid gap-4">
          {gateway.map((method, index) => (
            <div
              key={method.id}
              onClick={() => {
                setSelectedGateway(method.id);
                setSelectedGatewayIndex(index);
              }}
              className={`flex items-center justify-between p-4 border rounded-md cursor-pointer transition hover:shadow-md ${selectedGateway === method.id
                ? "bg-blue-100 border-blue-500 dark:bg-blue-700 dark:border-blue-400"
                : "bg-white dark:bg-stone-700 border-gray-300 dark:border-stone-600"
                }`}
            >
              <div className="flex items-center space-x-3">
                <span className="text-xl">{method.icon}</span>
                <div>
                  <p className="font-semibold">{method.title}</p>
                  <p className="text-sm text-gray-500 dark:text-stone-300">
                    {method.description}
                  </p>
                </div>
              </div>
              <div className="text-sm text-blue-600 dark:text-blue-300">
                {selectedGateway === method.id ? "Selected" : "Choose"}
              </div>
            </div>
          ))}
        </div>

        <form onSubmit={handleSubmit} className="mt-6">
          <button
            type="submit"
            className="w-full bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 text-white py-3 rounded-md text-lg font-medium transition"
          >
            Proceed to Payment
          </button>
        </form>

        <p className="text-xs text-gray-500 dark:text-stone-400 text-center mt-4">
          You can cancel anytime before confirmation.
        </p>

        {/* PayPal Modal */}
        <Modal
          title="Pay with PayPal"
          open={isPaypalModalOpen}
          onCancel={() => setIsPaypalModalOpen(false)}
          footer={null}
          style={{ maxHeight: "500px", overflowY: "scroll" }}
        >
          <div className="p-2">
            <PayPalButtons
              // createOrder={(data, actions) => {
              //   return actions.order.create({
              //     purchase_units: [
              //       {
              //         amount: {
              //           value:
              //             (paymentDetails?.subscriptionPricing.price ||
              //               paymentDetails?.book?.price ||
              //               defaultPaymentDetails?.amount ||
              //               0) + "",
              //           currency_code: "USD",
              //         },
              //       },
              //     ],
              //     intent: "CAPTURE",
              //   });
              // }}
              // onApprove={(data, actions) => {
              //   if (actions.order) {
              //     return actions.order.capture().then((details) => {
              //       console.log("Transaction completed");
              //       setIsPaypalModalOpen(false);
              //     });
              //   }
              //   return Promise.resolve();
              // }}
              createOrder={async () => {
                try {
                  const response = await userGetBookPaypalCreateOrder({
                    paymentToken: URLSearchParams?.get("token") || "0",
                  });

                  const orderData = await response;

                  console.log("Order Data:", orderData);

                  if (orderData.data.orderId) {
                    return orderData.data.orderId;
                  } else {
                    const errorDetail = orderData?.details?.[0];
                    const errorMessage = errorDetail
                      ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                      : JSON.stringify(orderData);

                    throw new Error(errorMessage);
                  }
                } catch (error: any) {
                  console.error(error);
                  alert(
                    `Could not initiate PayPal Checkout...${error?.response?.data?.message}`
                  );
                }
              }}
              onApprove={async (data, actions) => {
                try {
                  const response = await userGetBookPaypalCapture(data.orderID);

                  const orderData = await response;
                  // Three cases to handle:
                  //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                  //   (2) Other non-recoverable errors -> Show a failure message
                  //   (3) Successful transaction -> Show confirmation or thank you message

                  const errorDetail = orderData?.details?.[0];

                  if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                    // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                    return actions.restart();
                  } else if (errorDetail) {
                    // (2) Other non-recoverable errors -> Show a failure message
                    throw new Error(
                      `${errorDetail.description} (${orderData.debug_id})`
                    );
                  } else {
                    // (3) Successful transaction -> Show confirmation or thank you message
                    // Or go to another URL:  actions.redirect('thank_you.html');
                    const transaction =
                      orderData.purchase_units[0].payments.captures[0];
                    alert(
                      `Transaction ${transaction.status}: ${transaction.id}. See console for all available details`
                    );
                    console.log(
                      "Capture result",
                      orderData,
                      JSON.stringify(orderData, null, 2)
                    );
                  }
                } catch (error: any) {
                  console.error(error);
                  alert(
                    `Sorry, your transaction could not be processed...${error?.response?.data?.message}`
                  );
                }
              }}
            />
          </div>
        </Modal>

        <Modal
          title="Pay with Stripe"
          open={isStripeModalOpen}
          onCancel={() => setIsStripeModalOpen(false)}
          footer={null}
        >
          {stripeClientSecret && (
            <Elements
              stripe={stripePromise}
              options={{ clientSecret: stripeClientSecret }}
            >
              <StripeCheckoutForm onClose={() => setIsStripeModalOpen(false)} />
            </Elements>
          )}
        </Modal>

      </div>{" "}
    </div>
  );
};

export default OnlinePayment;


const StripeCheckoutForm = ({ onClose }) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleStripeSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin + "/payment-success",
      },
    });

    if (error) {
      alert(error.message);
    }
  };

  return (
    <form onSubmit={handleStripeSubmit}>
      <PaymentElement />
      <button
        type="submit"
        className="w-full mt-4 bg-blue-700 text-white py-2 rounded"
      >
        Pay with Stripe
      </button>
    </form>
  );
};
